import { useMutation, UseMutationResult, useQueryClient } from "@tanstack/react-query";
import { usersApi } from "../api";


interface UseLockUsersProps {
  userId: string;
  setOpen: (open: boolean) => void;
  invalidateKeys?: readonly unknown[][];
}

interface useLockUsersState {
    lockUserMutation: UseMutationResult<void, Error, string>;
    unlockUserMutation: UseMutationResult<void, Error, string>;
}

export const useLockUsers = ({userId, setOpen, invalidateKeys}: UseLockUsersProps): useLockUsersState => {
  const queryClient = useQueryClient();

  const invalidateAll = () => {
    const keys = invalidateKeys ?? [['benefactor', userId]];
    keys.forEach((queryKey) => queryClient.invalidateQueries({queryKey}));
  };

  const lockUserMutation = useMutation<void, Error, string>({
    mutationFn: () => usersApi.lockUser(userId),
    onSuccess: () => {
      invalidateAll();
      setOpen(false);
    },
  });

  const unlockUserMutation = useMutation<void, Error, string>({
    mutationFn: () => usersApi.unlockUser(userId),
    onSuccess: () => {
      invalidateAll();
      setOpen(false);
    },
  });

  return {lockUserMutation, unlockUserMutation};
};
